import React, { useContext, useEffect, useState } from 'react';

import {
    Card, 
    CardHeader,    
    CardContent,
    Grid,
    Button,
    CardActions,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Avatar,    
    Typography
} from '@material-ui/core';

import { SearchUser } from '../../../../common';

import { RolesContext } from '../RolesContext';
import { NavContext, NavRoutes, FetchContext, ApiRoutes, HttpMethods  } from '../../../../contexts';
import { ApplicationRoles, SapTableNames, LocalTableNames, } from '../../../../../helpers';

import PersonIcon from '@material-ui/icons/PersonOutlined'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    formGroup: {
        width: '100%',
    },
    select: {
        width: '100%'
    },
    user: {
        display: 'flex',
        alignItems: 'center',
    },    
    label: {
    },      
    avatar: {
        marginRight: theme.spacing(1)
    },    
    email: {
        marginLeft: theme.spacing(1)
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },    
    changeButton: {
        marginLeft: theme.spacing(3)
    }
}));

export const RoleAssigmentForm = ({ editMode, ...props }) => {
    const classes = useStyles();    
    const { fetchAuthorized } = useContext(FetchContext);
    const { navigateTo } = useContext(NavContext);

    const { 
        state,
        isAddingInRole,
        addUserInRole,
        isUpdatingInRole,
        updateUserInRole
    } = useContext(RolesContext);

    const {
        role,
        user
    } = state;

    const loadUsers = (inputValue, callback) => {
        return fetchAuthorized(ApiRoutes.Graph.GetUsers({ userFullPartialName: inputValue }),
        {
            method: HttpMethods.GET
        })
        .then(r => r.json())
        .then(users => callback(users))
        .catch(error => {
            console.error(error);
            callback([]);
        });
    }

    const [userKey, setUserKey] = useState(null);
    const userChangeHandler = (user) => {
        setUserKey(user ? user.id : null);
    }

    const saveClickHandler = async () => { 
        let success = false;
        if(!editMode) {
            success = await addUserInRole({ 
                userKey: userKey,
                roleId: state.role.applicationRoleId                 
            });              
        } else {
            success = await updateUserInRole({ 
                userKey: state.user.externalKey, 
                roleId: state.role.applicationRoleId            
             });
        } 
        
        if(success)
            navigateTo(NavRoutes.Admin.EditRole, [state.role.applicationRoleId]);
    }    

    const [allowSave, setAllowSave] = useState(false);
    useEffect(() => {
        if(role != null) {
            switch(role.name) {                        
                default:
                    setAllowSave(userKey !== null);
                    break;
            }
        }
    }, [role, user, userKey])    
    
    const [disabled, setDisabled] = useState(false);
    useEffect(() => {
        setDisabled(isAddingInRole || isUpdatingInRole);
    }, [isAddingInRole, isUpdatingInRole])

    return (        
        <Card className={classes.root}>
            <CardHeader title={userKey ? 
                `Add user in the '${state.role ? state.role.groupName : "unknown"}' group` : `Edit user in the '${state.role ? state.role.groupName : "unknown"}' group`} />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        {editMode && state.user ? 
                            <>
                                <Typography variant="overline" className={classes.label}>Target User</Typography>
                                <div className={classes.user}>
                                    <Avatar aria-label="recipe" className={classes.avatar}>
                                        <PersonIcon />
                                    </Avatar>   
                                    <Typography>
                                        {state.user.displayName}
                                    </Typography>
                                    <Typography className={classes.email}>
                                        ({state.user.email || "no email"})
                                    </Typography>    
                                </div>  
                            </>                              
                            :
                            <div className={classes.formGroup}>                          
                                <SearchUser 
                                    label="Target user"
                                    getOptionLabel={option => `${option.displayName} (${option.mail})`}
                                    getOptionValue={option => option.id}                    
                                    loadOptions={loadUsers}
                                    disabled={disabled}
                                    onChange={userChangeHandler}/>
                            </div>
                        }                   
                    </Grid>
                </Grid>                
            </CardContent>
            <CardActions>
                <Button 
                    color="primary" 
                    variant="contained"
                    disabled={!allowSave || disabled}
                    onClick={saveClickHandler}>
                    {editMode ? "Save Changes" : "Add User"}
                </Button>
            </CardActions>
        </Card>
    );
}